import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Picker, View, Text } from 'react-native';

class BlockTreeSelect extends Component {
  state = {
    visibleParents: [],
    parents: [],
    value: []
  }

  componentDidMount() {
    const { block } = this.props;
    let parents = [];

    // отбираем id родителей
    block.tree.forEach(element => {
      if (!parents.includes(element.parentId)) {
        parents.push(element.parentId);
      }
    });

    // находим кто из них первый
    let firstParent = block.tree.find(element => !element.parentId);
    let firstParentId = firstParent.id;

    // сразу делаем видимым первого родителя
    let visibleParents = [firstParentId];

    this.setState({
      parents,
      visibleParents
    });
  }

  handlerChange = (itemValue, parent, i) => {
    itemValue = parseInt(itemValue);
    const { block, onChange } = this.props;
    const { visibleParents, parents, value } = this.state;

    let parentIndex = visibleParents.indexOf(parent);
    let newVisibleParents = [...visibleParents];
    let newValue = [...value];
    newValue[parentIndex] = itemValue;

    // оставляем только паренты ДО текущего
    newVisibleParents.splice(parentIndex + 1);
    newValue.splice(parentIndex + 1);

    // если такой парент существует, но он ещё не отображается, добавляем к видимым
    if (parents.includes(itemValue) && !visibleParents.includes(itemValue)) {
      newVisibleParents = [...newVisibleParents, itemValue];
    }

    this.setState({
      visibleParents: newVisibleParents,
      value: newValue.filter(v=>v) // непустые значения
    });

    onChange && onChange({
      block,
      value: newValue,
      label: block.label
    });
  }

  render() {
    const { block } = this.props;
    const { parents, visibleParents, value } = this.state;

    return (
      <View key={parent} style={{
        marginTop: 15,
        marginRight: 15,
        marginBottom: 25,
        marginLeft: 15,
      }}><Text
        style={{
          marginTop: 5,
          marginBottom: 5,
          fontSize: 15
        }}>{block.label}</Text>
        {parents.map((parent, i) => <View key={parent} style={{
          display: visibleParents.includes(parent) ? 'flex' : 'none',
          marginTop: 5,
          marginBottom: 5,
        }}>
          <Picker
            selectedValue={value[visibleParents.indexOf(parent)]}
            style={{ height: 50, width: "100%" }}
            onValueChange={itemValue => this.handlerChange(itemValue, parent, i)}
          >
            <Picker.Item
              key={`default_${parent}`}
              label="-- выберите из списка --"
              value={0}
            />
            {block.tree.map((element) => element.parentId === parent ?
              <Picker.Item
                key={`default_${parent}_${element.id}`}
                label={element.name}
                value={element.id}
              />
              : null)}
          </Picker>
        </View>)
        }
      </View>
    );
  }
}

BlockTreeSelect.propTypes = {
  block: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.array
};

export default BlockTreeSelect;
